import { z } from 'zod';

// Zod 4 compiles object schemas into a function with `new Function`, and probes
// for that capability by evaluating `new Function('')` the first time any object
// schema is constructed (`allowsEval` in zod/v4/core/util, reached from
// `$ZodObjectJIT` in schemas). Our CSP carries no `'unsafe-eval'`, so the browser
// refuses it and files a `script-src` violation -- CSP-REPORTS-2, the largest
// single source of events in the Sentry org.
//
// Nothing breaks when it is refused: zod catches the error, `allowsEval` resolves
// false, and parsing falls through to the interpreted path with identical
// results. The probe is pure report noise. `jitless` skips it altogether, because
// `fastEnabled = jit && allowsEval.value` short-circuits before `.value` is read.
//
// This must run before the first object schema is *constructed*, not merely
// before the first parse: `$ZodObjectJIT` reads the flag once, at construction time.
// Route modules define schemas at module scope and the routers import them
// eagerly, so the import of this module has to come first in the entry point.
z.config({ jitless: true });
